import React from 'react'
import Wrapper, { IIconProps } from './Wrapper'

export default (props: IIconProps) => {
  return (
    <Wrapper {...props}>
      <svg
        viewBox='0 0 24 24'
        width='1em'
        height='1em'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g fill='none' fillRule='evenodd'>
          <path
            d='m10 15.06 3.053-3.06-3.053-3.06.94-.94 4 4-4 4z'
            fill='currentColor'
            fillRule='nonzero'
          />
          <path d='m0 0h24v24h-24z' />
        </g>
      </svg>
    </Wrapper>
  )
}
